/**
 * Partner payout calculator
 * monthly_payout = clients × plan_price × (rate / 100)
 * rate switches automatically at clients_threshold
 */
(function () {
  const SELECTOR = '[data-payout-calculator]';

  function parseNumber(value, fallback) {
    const n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function formatPayout(value) {
    return String(Math.round(value));
  }

  function getRate(clients, threshold, rateBase, rateScale) {
    return clients >= threshold ? rateScale : rateBase;
  }

  function initCalculator(root) {
    if (!root || root.dataset.payoutInit === 'true') return;
    root.dataset.payoutInit = 'true';

    const slider = root.querySelector('[data-payout-clients]');
    const sliderFill = root.querySelector('[data-payout-slider-fill]');
    const clientsValue = root.querySelector('[data-payout-clients-value]');
    const amountValue = root.querySelector('[data-payout-amount-value]');
    const amountEl = root.querySelector('[data-payout-amount]');
    const tierEl = root.querySelector('[data-payout-tier]');
    const tierNameEl = root.querySelector('[data-payout-tier-name]');
    const tierRateEl = root.querySelector('[data-payout-tier-rate]');
    const planButtons = Array.from(root.querySelectorAll('[data-payout-plan]'));

    if (!slider || !amountValue) return;

    const clientsMin = parseNumber(root.dataset.clientsMin, 1);
    const clientsMax = parseNumber(root.dataset.clientsMax, 100);
    const threshold = parseNumber(root.dataset.clientsThreshold, 10);
    const rateBase = parseNumber(root.dataset.rateBase, 20);
    const rateScale = parseNumber(root.dataset.rateScale, 35);
    const tierBaseLabel = root.dataset.tierBaseLabel || 'Partner';
    const tierScaleLabel = root.dataset.tierScaleLabel || 'Scale Partner';

    let clients = parseNumber(slider.value, parseNumber(root.dataset.clientsDefault, 20));
    let price = 0;
    let currentRate = getRate(clients, threshold, rateBase, rateScale);

    const selectedPlan = planButtons.find((btn) => btn.classList.contains('is-selected')) || planButtons[0];
    if (selectedPlan) {
      price = parseNumber(selectedPlan.dataset.price, 0);
    }

    function updateSliderProgress() {
      const range = clientsMax - clientsMin;
      const progress = range <= 0 ? 0 : ((clients - clientsMin) / range) * 100;
      if (sliderFill) {
        sliderFill.style.width = `${progress}%`;
      }
    }

    function triggerTierAnimation(didUpgrade) {
      if (!tierEl || !amountEl) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      tierEl.classList.remove('is-tier-up');
      amountEl.classList.remove('is-tier-up');
      // Force reflow so re-adding the class restarts the animation
      void tierEl.offsetWidth;

      if (didUpgrade) {
        tierEl.classList.add('is-tier-up');
        amountEl.classList.add('is-tier-up');
      }
    }

    function render() {
      const nextRate = getRate(clients, threshold, rateBase, rateScale);
      const isScale = clients >= threshold;
      const payout = clients * price * (nextRate / 100);
      const rateChanged = nextRate !== currentRate;
      const didUpgrade = rateChanged && nextRate > currentRate;

      if (clientsValue) clientsValue.textContent = String(clients);
      amountValue.textContent = formatPayout(payout);
      updateSliderProgress();

      if (tierEl) {
        tierEl.classList.toggle('is-scale', isScale);
      }
      if (tierNameEl) {
        tierNameEl.textContent = isScale ? tierScaleLabel : tierBaseLabel;
      }
      if (tierRateEl) {
        tierRateEl.textContent = `${nextRate}%`;
      }

      if (rateChanged) {
        triggerTierAnimation(didUpgrade);
      }

      currentRate = nextRate;
    }

    function selectPlan(button) {
      planButtons.forEach((btn) => {
        const selected = btn === button;
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      price = parseNumber(button.dataset.price, 0);
      render();
    }

    slider.addEventListener('input', () => {
      clients = parseNumber(slider.value, clients);
      render();
    });

    planButtons.forEach((button) => {
      button.addEventListener('click', () => selectPlan(button));
      button.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
          return;
        }
        event.preventDefault();
        const index = planButtons.indexOf(button);
        const delta = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1;
        const next = planButtons[(index + delta + planButtons.length) % planButtons.length];
        if (next) {
          next.focus();
          selectPlan(next);
        }
      });
    });

    render();
  }

  function initAll(scope) {
    const root = scope || document;
    root.querySelectorAll(SELECTOR).forEach(initCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
